import React, { Component } from 'react';

import logo from '../images/closeup-type.jpg';
import Social from './social'

export default class Home extends React.Component {
    render() {
      return (
        <div className="App-Body">
          <header className="App-header">
          </header>
          <div className="VBWhite">
          <div><img src={logo} className="App-logo" alt="logo" /></div>
            <div><p>Vanstone Bailey is a family run software consultancy specialising in </p>
              <ul> 
                <li>Microsoft's cloud computing platform, Azure</li>
                <li>Systems Integration</li>
                <li>Project Delivery</li>              
              </ul></div>
          </div>
          <div className="VBInverse">
            <div><p>Our core values are honesty, loyalty and commitment, which means that you will get:</p>
              <ul>
                <li>An honest assessment of the work that is needed and the status of delivery;</li>
                <li>Consultants who are committed to delivering great value for our clients</li>
                <li>Consultants who are loyal to the company and its clients</li>
              </ul>  
            </div>
            <div><p>Our consultants are expert .Net developers with experience including SQL, Dynamics CRM, Microsoft Azure, Dev Ops and integration tools. 
              Our MD is a Microsoft Azure MVP and often speaks at user groups and conferences. 
              He also regularly blogs on Azure related topics and has produced a number of supporting videos.
            </p></div>
            </div>
        </div>);
    }
  }